const RECORD_TYPES = Object.freeze(["physician", "location"]);

export const props = Object.freeze({
  /**
   * Endpoint the preview request is sent to.
   *
   * @type {String}
   * @default ""
   */
  previewUrl: {
    type: String,
    default: "",
  },
  /**
   * Kind of record the preview is for: `physician` or `location`.
   *
   * @type {String}
   * @default "physician"
   */
  recordType: {
    type: String,
    default: "physician",
    validator: (value) => RECORD_TYPES.includes(value),
  },
  /**
   * Id of the Physician or Location the preview is for.
   *
   * @type {String}
   * @default ""
   */
  recordId: {
    type: String,
    default: "",
  },
  /**
   * Display name of the record, shown in the drawer header.
   *
   * @type {String}
   * @default ""
   */
  recordName: {
    type: String,
    default: "",
  },
  /**
   * The id the EHR knows the record by, shown after its name in the drawer header.
   *
   * @type {String}
   * @default ""
   */
  ehrId: {
    type: String,
    default: "",
  },
  /**
   * Start date the form opens with, as `Y-m-d`.
   *
   * @type {String}
   * @default ""
   */
  defaultStartDate: {
    type: String,
    default: "",
  },
});
